const QuestionnaireEcommerceSettings = function ($scope, questionnaireInteractor, eventsService) {
  const $ctrl = this;

  $ctrl.$onChanges = () => {
    if ($ctrl.questionnaire) {
      $ctrl.initEcommerceInfo();
    } else {
      $ctrl.price = null;
    }
  };

  $ctrl.saveSettings = () => {
    return questionnaireInteractor.updateEcommerceSettings(
      $ctrl.questionnaire.id,
      parseFloat($ctrl.price) || 0.0,
      $ctrl.publiclyAvailable,
      $ctrl.shortDescription)
      .then(updatedPrice => {
        $ctrl.questionnaire.price = updatedPrice;
        $ctrl.questionnaire.short_description = $ctrl.shortDescription;
        $ctrl.questionnaire.publiclyAvailable = $ctrl.publiclyAvailable;
        $ctrl.initEcommerceInfo();
        eventsService.publishSystemMessage('Ecommerce settings have been updated');
        $scope.$digest();
      }, response => {
        eventsService.publishSystemError('Failed to update ecommerce settings ' + response.message);
      });
  };

  $ctrl.initEcommerceInfo = () => {
    $ctrl.shortDescription = $ctrl.questionnaire.short_description || '';
    $ctrl.publiclyAvailable = $ctrl.questionnaire.publiclyAvailable;
    if ($ctrl.questionnaire.price > 0) {
      $ctrl.price = $ctrl.questionnaire.price.toFixed(2);
    } else {
      $ctrl.price = null;
    }
  };

  $ctrl.resetChanges = () => {
    return Promise.resolve().then(() => $ctrl.initEcommerceInfo());
  };

  $ctrl.isSaveDisabled = () => !$ctrl.isPriceValid();

  $ctrl.limitShortDescLength = () => {
    if ($ctrl.shortDescription.length > 200) {
      $ctrl.shortDescription = $ctrl.shortDescription.substr(0, 200);
    }

    $ctrl.shortDescCharCount = $ctrl.shortDescription.length;
  };

  $ctrl.isPriceValid = () => $ctrl.price == 0.0 ||
    $ctrl.price >= 1.00 ||
    $ctrl.price == null;

  $ctrl.formatPrice = () => {
    let m = $ctrl.price.match(/\d+\.\d{2}/);
    if (m) {
      if ($ctrl.price.match(/\d+\.\d{2,}/)) $ctrl.price = m[ 0 ]
    }
  };

};

export default {
  name: 'questionnaireEcommerceSettings',
  obj: {
    controller: QuestionnaireEcommerceSettings,
    templateUrl: 'components/questionnaire_ecommerce_settings.html',
    bindings: {
      questionnaire: '<'
    }
  },
  deps: []
}